import styled from 'styled-components';

const StyledInput = styled.input`
  height: 70px;
  width: 100%;
  padding: 10px 20px;
  background-color: ${({ theme }) => theme.background.primary};
  border: 1px solid ${({ theme }) => theme.text.secondary};
  color: ${({ theme }) => theme.text.secondary};
  font-size: 20px;
  font-family: Manrope;
  text-align: right;
  &:focus {
    padding: 10px 20px;
  }
`;

const InputContainer = styled.div`
  display: flex;
  width: fit-content;
  max-width: 719px;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  position: relative;
`;

const Label = styled.p`
  font-family: Manrope;
  color: ${({ theme }) => theme.text.primary};
  font-size: 12px;
  font-weight: 400;
`;

export const ErrorLabel = styled.p`
  margin-top: 5px;
  font-family: Manrope;
  color: ${({ theme }) => theme.status.error.primary};
  font-size: 12px;
  font-weight: 400;
  &::first-letter {
    text-transform: uppercase;
  }
`;

const ImageContainer = styled.div`
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  padding: 0px 20px;
  display: flex;
  align-items: center;
  gap: 16px;
`;

const Image = styled.img`
  width: 36px;
  height: 36px;
`;

const NameContainer = styled.div``;

const Name = styled.p`
  color: ${({ theme }) => theme.text.regular};
  font-size: 20px;
  font-weight: 500;
  font-family: Manrope;
`;

const TokenInput = ({
  disabled = false,
  type = 'text',
  tokenType = 'usd',
  label,
  value,
  onChange,
  onBlur,
  error,
}) => {
  return (
    <>
      <InputContainer>
        {label && <Label className='label'>{label}&nbsp;</Label>}
        <StyledInput
          disabled={disabled}
          type={type}
          onBlur={onBlur}
          className='input'
          value={value}
          onChange={(event) => onChange(event.target.value)}
        />
        {error && <ErrorLabel>{error}</ErrorLabel>}
        <ImageContainer>
          {tokenType === 'usd' && (
            <>
              <Image src='/usd.webp' />
              <NameContainer>
                <Name>USD</Name>
              </NameContainer>
            </>
          )}
          {tokenType === 'vets' && (
            <>
              <Image src='/vets.webp' />
              <NameContainer>
                <Name>VETS</Name>
              </NameContainer>
            </>
          )}
          {tokenType === 'usdc' && (
            <>
              <Image src='/usdc.webp' />
              <NameContainer>
                <Name>USDC</Name>
              </NameContainer>
            </>
          )}
        </ImageContainer>
      </InputContainer>
    </>
  );
};

export default TokenInput;
